import React from 'react'
import reactCSS from 'reactcss'
import { EditableInput } from 'react-color/lib/components/common'
import color from 'react-color/lib/helpers/color'


export class ColorPickerFields extends React.Component {

    state = {
        view: 'hex',
    };

    handleChange = (data, e) => {
        if (data.hex && data.hex.length > 5) {
            color.isValidHex(data.hex) && this.props.onChange({
                hex: data.hex,
                source: 'hex',
            }, e)
        } else if (data.r || data.g || data.b) {
            this.props.onChange({
                r: data.r || this.props.rgb.r,
                g: data.g || this.props.rgb.g,
                b: data.b || this.props.rgb.b,
                source: 'rgb',
            }, e)
        } else if (data.a) {
            if (data.a < 0) {
                data.a = 0
            } else if (data.a > 1) {
                data.a = 1
            }

            this.props.onChange({
                h: this.props.hsl.h,
                s: this.props.hsl.s,
                l: this.props.hsl.l,
                a: Math.round(data.a * 100) / 100,
                source: 'rgb',
            }, e)
        } else if (data.h || data.s || data.l) {
            this.props.onChange({
                h: data.h || this.props.hsl.h,
                s: (data.s && data.s) || this.props.hsl.s,
                l: (data.l && data.l) || this.props.hsl.l,
                source: 'hsl',
            }, e)
        }
    }

    render() {
        const styles = reactCSS({
            'default': {
                wrap: {
                    paddingTop: '16px',
                    display: 'flex',
                },
                fields: {
                    flex: '1',
                    display: 'flex',
                    marginLeft: '-6px',
                },
                field: {
                    paddingLeft: '6px',
                    width: '100%',
                },
                input: {
                    fontSize: '1em',
                    color: '#333',
                    width: '100%',
                    borderRadius: '2px',
                    border: 'none',
                    boxShadow: 'inset 0 0 0 1px #dadada',
                    height: '21px',
                    textAlign: 'center',
                },
                label: {
                    textTransform: 'uppercase',
                    fontSize: '11px',
                    lineHeight: '11px',
                    color: '#969696',
                    textAlign: 'center',
                    display: 'block',
                    marginTop: '12px',
                },
            },
        }, this.props, this.state)

        return (
            <div style={ styles.wrap } className="flexbox-fix">
                <div style={ styles.fields } className="flexbox-fix">
                    <div style={ styles.field }>
                        <EditableInput
                            style={{ input: styles.input, label: styles.label }}
                            label="hex" value={ this.props.hex }
                            onChange={ this.handleChange }
                            onChangeComplete={this.props.onChangeComplete}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default ColorPickerFields



// WEBPACK FOOTER //
// ./src/components/recoloring/ColorPickerFields.js